"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column_1 = require("./Column");

function filterProps(name) {
  return {
    Argument: [],
    HasFilter: false,
    Name: name,
    Operator: 'None',
    Text: null
  };
}

var NumericOperators = [{
  Value: Column_1.CompareOperators.NONE,
  Title: 'None'
}, {
  Value: Column_1.CompareOperators.EQUALS,
  Title: 'Equals'
}, {
  Value: Column_1.CompareOperators.BETWEEN,
  Title: 'Between'
}, {
  Value: Column_1.CompareOperators.GTE,
  Title: '>='
}, {
  Value: Column_1.CompareOperators.GT,
  Title: '>'
}, {
  Value: Column_1.CompareOperators.LTE,
  Title: '<='
}, {
  Value: Column_1.CompareOperators.LT,
  Title: '<'
}];
var StringOperators = [{
  Value: Column_1.CompareOperators.NONE,
  Title: 'None'
}, {
  Value: Column_1.CompareOperators.EQUALS,
  Title: 'Equals'
}, {
  Value: Column_1.CompareOperators.NOT_EQUALS,
  Title: 'Not Equals'
}, {
  Value: Column_1.CompareOperators.CONTAINS,
  Title: 'Contains'
}, {
  Value: Column_1.CompareOperators.NOT_CONTAINS,
  Title: 'Not Contains'
}, {
  Value: Column_1.CompareOperators.STARTS_WITH,
  Title: 'Starts With'
}, {
  Value: Column_1.CompareOperators.NOT_STARTS_WITH,
  Title: 'Not Starts With'
}, {
  Value: Column_1.CompareOperators.ENDS_WITH,
  Title: 'Ends With'
}, {
  Value: Column_1.CompareOperators.NOT_ENDS_WITH,
  Title: 'Not Ends With'
}];
var BooleanOperators = [{
  Value: Column_1.CompareOperators.NONE,
  Title: 'None'
}, {
  Value: Column_1.CompareOperators.EQUALS,
  Title: 'Equals'
}, {
  Value: Column_1.CompareOperators.NOT_EQUALS,
  Title: 'Not Equals'
}];

var ColumnModel =
/** @class */
function () {
  function ColumnModel(name, options) {
    this.hasFilter = this.Filter && (this.Filter.Text || this.Filter.Argument) && this.Filter.Operator !== Column_1.CompareOperators.NONE;
    this.Aggregate = options && options.Aggregate || Column_1.AggregateFunctions.NONE;
    this.DataType = options && options.DataType || Column_1.ColumnDataType.STRING;
    this.IsKey = options && options.IsKey || false;
    this.Label = options && options.Label || (name || '').replace(/([a-z])([A-Z])/g, '$1 $2');
    this.Name = name;
    this.Searchable = options && options.Searchable || false;
    this.SortDirection = options && options.Sortable && options.SortDirection || Column_1.ColumnSortDirection.NONE;
    this.SortOrder = options && this.SortDirection !== Column_1.ColumnSortDirection.NONE && options.SortOrder || -1;
    this.Sortable = options && options.Sortable || false;
    this.Visible = options && typeof options.Visible === 'boolean' ? options.Visible : true;
    this.Filter = options && options.Filterable ? filterProps(name) : {};
    this.Filterable = options && options.Filterable || false;
    this.Filter.HasFilter = this.hasFilter;
  }

  ColumnModel.createFilterPatch = function (column) {
    var filterText = column.Filter.Text;
    var filterArgument = column.Filter.Argument[0];

    if (column.DataType === Column_1.ColumnDataType.NUMERIC) {
      filterText = parseFloat(filterText);
      filterArgument = parseFloat(filterArgument);
    } else if (column.DataType === Column_1.ColumnDataType.BOOLEAN) {
      filterText = filterText === 'true';
      filterArgument = '';
    }

    return {
      Argument: [filterArgument],
      HasFilter: true,
      Operator: column.Filter.Operator || Column_1.CompareOperators.AUTO,
      Text: filterText
    };
  };

  ColumnModel.getOperators = function (column) {
    switch (column.DataType) {
      case Column_1.ColumnDataType.STRING:
        return StringOperators;

      case Column_1.ColumnDataType.NUMERIC:
      case Column_1.ColumnDataType.DATE:
      case Column_1.ColumnDataType.DATE_TIME:
      case Column_1.ColumnDataType.DATE_TIME_UTC:
        return NumericOperators;

      case Column_1.ColumnDataType.BOOLEAN:
        return BooleanOperators;

      default:
        return [];
    }
  };

  ColumnModel.sortColumnArray = function (columnName, columns, multiSort) {
    var column = columns.find(function (c) {
      return c.Name === columnName;
    });

    if (!column) {
      return;
    }

    column.SortDirection = column.SortDirection === Column_1.ColumnSortDirection.NONE ? Column_1.ColumnSortDirection.ASCENDING : column.SortDirection === Column_1.ColumnSortDirection.ASCENDING ? Column_1.ColumnSortDirection.DESCENDING : Column_1.ColumnSortDirection.NONE;
    column.SortOrder = column.SortDirection === Column_1.ColumnSortDirection.NONE ? -1 : Number.MAX_VALUE;

    if (!multiSort) {
      columns.filter(function (col) {
        return col.Name !== columnName;
      }).forEach(function (c) {
        c.SortOrder = -1;
        c.SortDirection = Column_1.ColumnSortDirection.NONE;
      });
    }

    columns.filter(function (col) {
      return col.SortOrder > 0;
    }).sort(function (a, b) {
      return a.SortOrder === b.SortOrder ? 0 : a.SortOrder > b.SortOrder ? 1 : -1;
    }).forEach(function (col, i) {
      col.SortOrder = i + 1;
    });
    return columns;
  };

  ColumnModel.clearFilterPatch = function () {
    return {
      Argument: [''],
      HasFilter: false,
      Operator: Column_1.CompareOperators.NONE,
      Text: ''
    };
  };

  return ColumnModel;
}();

exports["default"] = ColumnModel;